import { makeStyles } from '@material-ui/core/styles'
import brandTheme from '../../Assets/Styles/brandTheme'

const drawerWidth = 250
const {
  colors: { primary },
} = brandTheme()

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  wrapperSidebar: {
    position: 'relative',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',

    '& .MuiDrawer-paper': {
      top: 'inherit',
      background: '#F9F9FF',
      borderRight: '1px solid #E2E2FC',
      zIndex: 1040,
      padding: 8,
      position: 'absolute',
      minHeight: 'calc(100vh - 136px)',
      height: '-webkit-fill-available',
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 17,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    background: '#F9F9FF',
    borderRight: '1px solid #E2E2FC',
  },
  button: {
    background: '#FFFFFF',
    position: 'absolute',
    right: '-16px',
    padding: 4,
    boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.1)',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
      backgroundColor: '#FFFFFF',
      transform: 'scale(1.2)',
    },
  },
  content: {
    width: '100%',
    // height: 'calc(100vh - 72px)',
  },
  itemsWrap: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 9px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px',
    cursor: 'pointer',
  },
  logoWrap: {
    display: 'flex',
    padding: '9px 16px',
    cursor: 'pointer',
    borderRadius: '12px',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  active: {
    background: primary,
  },
  activeText: {
    color: '#FFFFFF !important',
  },
  nameWrap: {
    color: '#273754',
    fontWeight: '700',
    fontSize: '16px',
    marginLeft: '12px',
    lineHeight: '22px',
    paddingLeft: '10px',
  },
  link: {
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
    },
  },
  submenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '4px',
  },
  subItem: {
    display: 'flex',
    padding: '8px 0px 8px 48px',
    alignItems: 'center',
    fontSize: '16px',
    borderRadius: '8px',
    width: '100%',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: '#D1D1FA',
    },
  },
  subItemLink: {
    textDecoration: 'none !important',
    color: 'inherit',
    width: '100%',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:visited': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
    '&:active': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
  },
  subItemText: {
    color: '#273754',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  subItemActive: {
    background: '#E2E2FC',
    fontWeight: 500,
  },
}))
